import {
    ssoConfigListRequest, createSsoConfigRequest,
    updateSsoConfigRequest, deleteSsoConfigRequest
} from "../service/ssoConfigService"
import { SsoConfigPayload, DeleteSsoConfigPayload, SsoConfigDetail, SsoConfigSaveResponse } from "../model/ssoConfigPayload"

const fetchSsoConfigsRequest = () => {
    return {
        type: "SSO_CONFIG_LIST_REQUEST"
    }
}

const fetchSsoConfigsSuccess = (data: SsoConfigDetail[]) => {
    return {
        type: "SSO_CONFIG_LIST_SUCCESS",
        payload: data
    }
}

const fetchSsoConfigsError = (error: string) => {
    return {
        type: "SSO_CONFIG_LIST_ERROR",
        payload: error
    }
}

const saveSsoConfigRequest = () => {
    return {
        type: "SSO_CONFIG_SAVE_REQUEST"
    }
}

const saveSsoConfigSuccess = (data: SsoConfigSaveResponse) => {
    return {
        type: "SSO_CONFIG_SAVE_SUCCESS",
        payload: data
    }
}

const saveSsoConfigError = (error: string) => {
    return {
        type: "SSO_CONFIG_SAVE_ERROR",
        payload: error
    }
}

const deleteSsoConfigRequestAction = () => {
    return {
        type: "SSO_CONFIG_DELETE_REQUEST"
    }
}

const deleteSsoConfigSuccess = () => {
    return {
        type: "SSO_CONFIG_DELETE_SUCCESS"
    }
}

const deleteSsoConfigError = (error: string) => {
    return {
        type: "SSO_CONFIG_DELETE_ERROR",
        payload: error
    }
}

export const closeSsoConfigModal = () => {
    return {
        type: "SSO_CONFIG_CLOSE_MODAL"
    }
}

export const clearSsoConfigStore = () => {
    return {
        type: "CLEAR_SSO_CONFIG_STORE"
    }
}

export const fetchSsoConfigs = (partnerId: number, authToken: string) => {
    return function (dispatch: any) {
        dispatch(fetchSsoConfigsRequest());
        ssoConfigListRequest(partnerId, authToken)
            .then(responseData => {
                dispatch(fetchSsoConfigsSuccess(responseData))
            })
            .catch(error => {
                dispatch(fetchSsoConfigsError(String(error)));
            });
    };
}

export const saveSsoConfig = (payload: SsoConfigPayload, isEdit: boolean, authToken: string) => {
    return function (dispatch: any) {
        dispatch(saveSsoConfigRequest());
        const request = isEdit ? updateSsoConfigRequest : createSsoConfigRequest
        request(payload, authToken)
            .then(responseData => {
                dispatch(saveSsoConfigSuccess(responseData))
            })
            .catch(error => {
                dispatch(saveSsoConfigError(String(error)));
            });
    }
}

export const deleteSsoConfig = (payload: DeleteSsoConfigPayload, authToken: string) => {
    return function (dispatch: any) {
        dispatch(deleteSsoConfigRequestAction());
        deleteSsoConfigRequest(payload, authToken)
            .then(_ => {
                dispatch(deleteSsoConfigSuccess())
            })
            .catch(error => {
                dispatch(deleteSsoConfigError(String(error)));
            });
    }
}
